import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import FooterModal from './../Footer/FooterModal';
import './CookieBanner.css';

/**
 * Components CookieBanner
 * @param {object} props.translations
 * @param {string} props.legalInfo
 */
const CookieBanner = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const [modalVisibleState, setModalVisibleState] = useState(false);
  const [cookies, setCookie] = useCookies(['useCookies']);
  // const [removeCookie] = useCookies(['useCookies']);
  // removeCookie('useCookies');

  useEffect(() => {
    if(cookies.useCookies === undefined) {
      setIsVisible(true);
    }
  }, [cookies]);

  /**
   * On cache la modal
   */
  const handleHideModal = () => {
    setModalVisibleState(false);
  }

  /**
   * On affiche la modal
   */
  const handleShowModal = (event) => {
    setModalVisibleState(true);
  }

  /**
   * event lors que l'on click sur le btn valid les cookies
   */
  const handleClick = () => {
    setCookie('useCookies', new Date(), {
      secure : true,//cookies fonction uniqement avec https
      sameSite : 'strict' 
    });
    setIsVisible(false);
  }
  
  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    (isVisible && props.translations && props.translations.cookiesMessage) ? 
    <div>
      <FooterModal type="privacyPolicy" isVisible={modalVisibleState} handleClose={handleHideModal} translations={props.translations} legalInfo={props.legalInfo}/>
      <div className="cookieBanner">
        <span className="cookieMessage">
          {props.translations.cookiesMessage}
          <div id="divCookiesLearnMore" onClick={handleShowModal}>{props.translations.cookiesLearnMore}</div>
        </span>
        <button className="buttonClose" onClick={handleClick}>{props.translations.close}</button>
      </div>
    </div>
    : null
  )
}

export default CookieBanner;